import { render } from "./Rates.vue?vue&type=template&id=53187fd0&scoped=true"
import script from "./Rates.vue?vue&type=script&lang=js"
export * from "./Rates.vue?vue&type=script&lang=js"

import "./Rates.vue?vue&type=style&index=0&id=53187fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53187fd0"]])

export default __exports__